import { ITranslations } from 'types/common';
import { PointsTransFields } from './types';
import en from 'translations/en/points.json';
import pl from 'translations/pl/points.json';
import sl from 'translations/sl/points.json';

export const pointsTranslations: ITranslations<PointsTransFields> = {
  name: 'points',
  en,
  pl,
  sl,
};
